import { DOMAIN, SECURE } from './cookies-config.js';

export const LOCAL_STORAGE_KEYS = {
	DEVICE_ID: 'device_id',
	AOFL_TOKEN: 'aofl_token',
	SOURCE_INFO: 'source_info'
};

export const AOFL_PRODUCT_NAMES = {
	ABCMOUSE: 'abcmouse_v2'
};

export const EVENT_NAMES = {
	CAMPAIGN_CLICK: 'marketing.campaign_click',
	LINK_CLICK: 'marketing.page_link_click',
	PAGE_LOAD: 'marketing.page_load',
	PIXEL_FIRE: 'marketing.pixel_fire',
	ROTATION_ASSIGN: 'marketing.rotation_assignment',
	VIDEO_PROGRESS: 'marketing.video_watched'
};

export const PLATFORMS = {
	DEFAULT: 'default_platform'
};


export const AOFL_PRODUCT_UUIDS = {
	ABCMOUSE_2_0: 'b2892456-6e59-11ee-b962-0242ac120002'
};

export const GTM_EVENT_NAMES = {
	CONVERSION: 'conversion',
	PROSPECT_REG_SUBMITTED: 'prospect-reg',
	LOGIN: 'login'
};

export const PAYMENT_TYPE = {
	CREDIT_CARD: 'paymentech',
	PAYPAL: 'paypal'
};

export const SUBSCRIPTION_TYPES = {
	NEW_SUBSCRIPTION: 'firstTimeSubscription',
	// covers both reactivation and buying additional products.
	EXISTING_SUBSCRIPTION: 'existingSubscription'
};

export const THIRD_PARTY_EVENT = {
	SUBSCRIBE: 'Subscribe',
	INITIATE_CHECKOUT: 'InitiateCheckout'
};

export const THIRD_PARTY_PARTNER = {
	BING: 'bing'
};

export const SUPPORTED_THIRD_PARTY_PARTNERS = [THIRD_PARTY_PARTNER.BING];

export const TRANSACTION_TYPE = {
	PREPROCESS: 'preprocess',
	PROCESS: 'process'
};

export const UsernameTypes = {
	EMAIL: 'email'
};

export const PAGES = {
	INTERNAL: {
		HOME: '/',
		SUBSCRIPTION: '/subscription',
		SUBSCRIPTION_CONSUME: '/subscription-consume',
		REACTIVATION: '/reactivation',
		UPGRADE: '/upgrade',
		PROSPECT_REGISTER: '/prospect-register',
		DOWNLOAD_APP: '/download-app',
		LOGIN: '/login',
		LOGOUT: '/logout',
		PARENT_SECTION: '/parent-section',
		IN_APP_DEEP_LINK: '/redirects/deep-link-to-in-app',
		RESET_PASSWORD: '/reset-password'
	},
	EXTERNAL: {
		ABCMOUSE: 'https://www.abcmouse.com',
		ABCMOUSE_SEO_GAMES_PAGE: 'https://www.abcmouse.com/games',
		AOFL_ABCMOUSE_COOKIE_POLICY: 'https://www.ageoflearning.com/abc-privacyandcookie/',
		AOFL_BRAND_ABCM: 'https://www.ageoflearning.com/brand/abcmouse_landing_v1',
		AOFL_FOR_SCHOOLS: 'https://www.ageoflearning.com/schools/',
		AOFL_DEVICES: 'https://www.ageoflearning.com/devices/aofl_devices_en.pdf',
		ACCESSIBILITY: 'https://www.ageoflearning.com/accessibility',
		CUSTOMER_SUPPORT: 'https://support.plus.abcmouse.com/hc/en-us',
		CUSTOMER_SUPPORT_CONTACT_US: 'https://support.abcmouse.com/hc/en-us/articles/360047572854',
		PRIVACY_PDF: 'https://img.abcmouse.com/pdf/privacy.pdf',
		PRIVACY_PORTAL:
			'https://privacyportal-cdn.onetrust.com/dsarwebform/a2692794-047c-4c18-b3bf-60d783ebc844/8205df50-001c-4e16-b5f9-d4e945bc612e.html',
		IPV6: 'https://ipv6.abcmouse.com/trk',
		ALLABOUT_DNT: 'http://www.allaboutdnt.org',
		CCPA_METRICS: 'https://www.ageoflearning.com/ccpa/',
		CUSTOMER_SUPPORT_FORGOT_EMAIL:
			'https://support.abcmouse.com/hc/en-us/articles/4413252218903-Account-Access',
		FORGOT_PASSWORD:
			'https://www.abcmouse.com/abc/forgot-password/',
		CUSTOMER_SUPPORT_FAQS:
			'https://support.abcmouse.com/hc/en-us/articles/360053552753-What-devices-should-I-use-with-ABCmouse-',
		AOFL_RESEARCH: 'https://www.ageoflearning.com/research/',
		GOOGLE_UCB_LEARN_MORE: 'https://support.google.com/googleplay/answer/11174377',
		HOMESCHOOLPLUS: 'https://www.homeschoolplus.com',
		HOMESCHOOLPLUS_SUBSCRIPTION: 'https://www.homeschoolplus.com/subscription/',
		SUNMAID_WALMART: 'https://www.walmart.com/cp/sunmaidbacktoschool/3335011',
		SUNMAID_SIGHT_WORDS_PDF: 'https://img.abcmouse.com/pdf/abcmouse_sunmaid_sight_words_rgb_06.pdf',
		SUNMAID_MATH_WITH_RAISINS_PDF: 'https://img.abcmouse.com/pdf/sunmaid_book_letter_12.pdf',
		SUNMAID_COLORING_PAGES_PDF: 'https://img.abcmouse.com/pdf/sunmaid_alphabet_coloring_pages.pdf',
		SUNMAID_LETTER_TRACING_PDF: 'https://img.abcmouse.com/pdf/abcmouse_letter_tracing.pdf',
		KID_SAFE: 'https://www.kidsafeseal.com/certifiedproducts/abcmouse.html',
		PRIVACY_DE: 'https://www.ageoflearning.com/abc-privacy-german',
		PRIVACY_SE: 'https://www.ageoflearning.com/abc-privacy-swedish',
		TANDC_DE: 'https://www.ageoflearning.com/abc-tandc-german',
		TANDC_SE: 'https://www.ageoflearning.com/abc-tandc-swedish',
		PRIVACY_HUB: 'https://www.ageoflearning.com/privacy-policies/',
		PRIVACY_POLICY: 'https://www.ageoflearning.com/abc-privacy-current/',
		PRIVACY_ES: 'https://www.ageoflearning.com/abc-privacy-current-es/',
		TERMS_CONDITIONS: 'https://www.ageoflearning.com/abc-tandc-current/',
		TERMS_CONDITIONS_ES: 'https://www.ageoflearning.com/abc-tandc-current-es/',
		TIKTOK: 'https://www.tiktok.com/@abcmouse',
		FACEBOOK: 'https://www.abcmouse.com/outsideurl?url=facebook',
		FACEBOOK_PAGE: 'https://www.facebook.com/ABCmouse/',
		FACEBOOK_GROUP: 'https://www.facebook.com/groups/abcmouse.orientation/about/',
		INSTAGRAM: 'https://www.instagram.com/abcmouse/',
		PINTEREST: 'https://www.abcmouse.com/outsideurl?url=pinterest',
		PINTEREST_PAGE: 'https://www.pinterest.com/abcmouse/',
		CAREERS: 'https://www.ageoflearning.com/careers/',
		AOFL: 'https://www.ageoflearning.com',
		MEDIA: 'https://www.ageoflearning.com/media/',
		IOS_APP_STORE: 'https://apps.apple.com/ca/app/abcmouse-2-0/id6460300848',
		GOOGLE_APP_STORE:
			'https://play.google.com/store/apps/details?id=com.aofl.abcmouse&hl=en_US&gl=CA&pli=1'
	}
};

export const OUTBOUND_PATH = (currentUrl = '') => {
	// TODO: remove this for a env var based solution.
	const isDevEnv = currentUrl.includes('dev') || currentUrl.includes('localhost');
	if (isDevEnv) {
		return {
			SUCCESS_SUB_DEEP_LINK_TO_APP: 'https://dev.app.abcmouse.com/refreshToken?token=',
			FAILURE_SUB_DEEP_LINK_TO_APP: 'https://dev.app.abcmouse.com?token='
		};
	}
	return {
		SUCCESS_SUB_DEEP_LINK_TO_APP: 'https://app.abcmouse.com/refreshToken?token=',
		FAILURE_SUB_DEEP_LINK_TO_APP: 'https://app.abcmouse.com?token='
	};
};

export const QUERY_PARAM_KEYS = {
	EMAIL_CLICK: '_0c83',
	ENV: 'env',
	GOTO: 'to',
	PRODUCT_HASH: 'productHash',
	PRODUCT_TYPE: 'b_term',
	SOURCE_TAG: 'src_tag',
	TOKEN: 'token',
};

export const QUERY_PARAM_VALUES = {
	B_TERM: {
		MONTHYL: 'monthly',
		ANNUAL: 'annual'
	}
};

export const CAMPAIGN_PIXEL_TYPES = {
	CONVERSION: 'conversion',
	LANDING: 'landing',
	PROSPECT_REGISTER: 'sign-up'
};

export const REG_PATH_KEYS = {
	DEFAULT_SUBSCRIBER: 'defaultSubscriber',
	DEFAULT_RESUBSCRIBER: 'defaultResubscriber',
	DEFAULT_IN_APP_CONSUMPTION: 'defaultInAppConsumption',
	DEFAULT_IN_APP_CONSUMPTION_RESUBSCRIBE: 'defaultInAppConsumptionResubscribe'
};

export const REG_PATH_STEPS = {
	COMPLETE: 'REGPATH_COMPLETE',
	SUBSCRIBED: 'REGPATH_SUBSCRIBED', // Step at which the user has subscribed.
	UPGRADE: 'REGPATH_UPGRADE',
	RESET: 'DEFAULT_STEP' // Step to reset a reg-path: should not be included in any reg-path, used primarily for reactivation users.
};

export const SUBSCRIPTION_HASHES = {
	PAYMENT_TECH: {
		monthly_fmf: 'f1eab9c7f585ee6e6b45e993af095abc96cbe361dc575f5539e3aaad0bc0a6a6', // $12.99
		semi_annual: 'a671ba9535d019ed4ae92f2974fe665bd1fd9f06e08f67aadaf9ccff719e46ac', // $25.00
		annual: '0276c52238259b3948b86616639ffaf3fa9be4eb89c976085b98835648eb9882', // $45.00
		upgrade: '0276c52238259b3948b86616639ffaf3fa9be4eb89c976085b98835648eb9882', // $45.00
		monthly_reactivation: 'ed789ce4963b763b69a4ab495da0e2b4a4d6d7b92dd8acf4e9217e7b24ea57ea', // $14.99
		semi_annual_reactivation: 'a671ba9535d019ed4ae92f2974fe665bd1fd9f06e08f67aadaf9ccff719e46ac', // $25.00
		annual_reactivation: '0276c52238259b3948b86616639ffaf3fa9be4eb89c976085b98835648eb9882', // $45.00
		annual_reactivation_upgrade: '0276c52238259b3948b86616639ffaf3fa9be4eb89c976085b98835648eb9882' // $45.00
	}
};

export const SUBSCRIPTION_STATUS = {
	OPTED_IN: 'opted_in',
	OPTED_OUT: 'opt_out',
	UNSUBSCRIBED: 'unsubscribed'
};

export const COOKIES = {
	CJ_COOKIE: 'cje',
	CONFIG: {
		secure: SECURE,
		domain: DOMAIN,
		expires: 365
	},
	COUNTRY_CODE: 'abcmouseCountryCode',
	FBC: '_fbc',
	FBP: '_fbp',
	GDPR: 'gdpr'
};

export const COOKIES_CONSENT = {
	ANALYTICS: 'ANALYTICS_PERFORMANCE_COOKIES',
	TARGETING: 'TARGETING_COOKIES'
};

// TODO: merge this, no reason to have a separate list.
/** @type {{[key:string]: string; }} */
export const COUNTRY_CODES_GDPR = {
	AT: 'Austria',
	AU: 'Australia',
	BE: 'Belgium',
	BG: 'Bulgaria',
	CY: 'Republic of Cyprus',
	CZ: 'Czech Republic',
	DE: 'Germany',
	DK: 'Denmark',
	EE: 'Estonia',
	ES: 'Spain',
	EU: 'European Union',
	FI: 'Finland',
	FR: 'France',
	GB: 'United Kingdom',
	GR: 'Greece',
	HU: 'Hungary',
	HR: 'Croatia',
	IE: 'Ireland',
	IT: 'Italy',
	LT: 'Lithuania',
	LU: 'Luxembourg',
	LV: 'Latvia',
	MT: 'Malta',
	NL: 'Netherlands',
	PL: 'Poland',
	PT: 'Portugal',
	RO: 'Romania',
	SE: 'Sweden',
	SK: 'Slovakia',
	SI: 'Slovenia',
	GDPR: 'GDPR'
};

export const COUNTRY_CODES_OPTIONAL_EMAIL_CAPTURE = {
	AU: 'AU',
	CA: 'CA'
};

export const CURRENCY_CODE = {
	AUSTRALIAN_DOLLAR: 'AUD',
	CANADIAN_DOLLAR: 'CAD',
	US_DOLLAR: 'USD'
};
